import { Column, Row, Typography } from '@tempmee/react';
import { colors, shadows } from '@tempmee/tailwind';

export const NotificationLayout = ({ Icon, title, children, style = { body: {} } }) => (
  <Column gap={5}>
    <div
      style={{
        backgroundColor: colors.neutral[100],
        borderRadius: 20,
        boxShadow: shadows['elevation-4'],
        overflow: 'hidden',
      }}
    >
      <Row
        align="center"
        gap={2}
        style={{ height: 48, padding: '0 20px' }}
      >
        <Icon color={colors.primary[500]} />
        <Typography bold color={colors.primary[500]} size="heading_4">
          {title}
        </Typography>
      </Row>
      <div
        style={{
          backgroundColor: colors.shades['0'],
          boxShadow: shadows['elevation-4'],
          padding: '8px 32px',
          borderTopLeftRadius: 25,
          borderTopRightRadius: 25,
          ...style.body,
        }}
      >
        {children}
      </div>
    </div>
  </Column>
);
